module.exports = __webpack_public_path__ + "media/message_tone.9773bb1e.mp3";